import React, { useState } from "react";
import { Select } from "antd";
import { searchByName } from "api";

const { Option } = Select;

let timeout;
let currentValue;

const PersonSearch = ({
	appHierarchyId,
	value,
	onChange,
	defaultOptions = [],
	options = {},
	style,
	placeholder = "Search for a person by their name (lastname, firstname)",
}) => {
	const [data, setData] = useState(defaultOptions);

	const { valueKey, includeLabel, disabled } = options;

	function fetch(value, callback) {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		currentValue = value;

		const query = async () => {
			const response = await searchByName({
				name: value,
				appHierarchyId,
			});
			if (currentValue === value) {
				const data = [];
				response.forEach((r) => {
					data.push({
						value: valueKey ? r[valueKey] : r["id"],
						text: r["lastName"] + ", " + r["firstName"],
					});
				});
				callback(data);
			}
		};
		timeout = setTimeout(query, 300);
	}

	const onSearch = (value) => {
		if (value) {
			fetch(value, (data) => setData(data));
		} else {
			setData([]);
		}
	};

	const triggerChange = (value) => {
		if (includeLabel)
			onChange?.({
				value,
				text: data.find((d) => d.value === value).text,
			});
		else onChange?.(value);
	};

	const selectOptions = data
		.sort((a, b) => (a.text === b.text ? 0 : a.text > b.text ? 1 : -1))
		.map((d, key) => {
			return (
				<Option key={key} value={d.value}>
					{d.text}
				</Option>
			);
		});

	return (
		<Select
			showSearch
			defaultValue={value}
			placeholder={placeholder}
			style={style}
			defaultActiveFirstOption={false}
			showArrow={false}
			filterOption={false}
			onSearch={onSearch}
			onChange={triggerChange}
			notFoundContent={null}
			disabled={disabled}
		>
			{selectOptions}
		</Select>
	);
};

export default PersonSearch;
